import { useEffect } from 'react'
import { toast } from 'sonner'

/** Recovery never dispatches deletion or logout requests. */
export function AccountDeletionRecovery() {
  useEffect(() => {
    let mounted = true
    const recover = async () => {
      try {
        const { resumeAccountDeletionCleanup } =
          await import('@/lib/auth/account-deletion-cleanup')
        await resumeAccountDeletionCleanup()
      } catch (error) {
        if (!mounted) return
        if (
          error instanceof Error &&
          error.name === 'AccountDeletionCleanupError'
        ) {
          toast.error('Local account cleanup needs to finish.', {
            id: 'account-deletion-cleanup',
            action: { label: 'Retry cleanup', onClick: () => void recover() },
          })
        } else
          console.warn('[AccountDeletion] Local recovery could not be checked')
      }
    }
    void recover()
    return () => {
      mounted = false
    }
  }, [])
  return null
}
